module.exports = __webpack_public_path__ + "static/img/yun01_3.49016ba.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/propaganda/yun01_3.jpg
// module id = p4Z/
// module chunks = 1